import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { PhysicianPortalSurveyQuestion as _PhysicianPortalSurveyQuestion } from '../PhysicianPortalSurveyQuestion';
import intToOrdinal from '../intToOrdinal';

const _question = Symbol();

class SurveyQuestion extends BaseElement {
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: block;
					padding: 0.5em;
				}
				.container {
					display: flex;
					flex-flow: row nowrap;
				}
				.container > * {
					flex: 1;
				}
				.container > .checkbox {
					flex: 0;
					margin-right: 0.5em;
				}
			`
		];
	}
	get question() {
		return this[_question];
	}
	set question(v) {
		if(!(v instanceof _PhysicianPortalSurveyQuestion))
			throw new TypeError('question must be an instance of PhysicianPortalSurveyQuestion.');
		this[_question] = v;

		this.requestUpdate();
	}
	get checked() {
		return this.shadowRoot.querySelector('input[type="checkbox"]').checked;
	}
	set checked(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('checked must be a boolean.');
		this.shadowRoot.querySelector('input[type="checkbox"]').checked = v;
	}
	render() {
		return html`
			<div class="container">
				<div class="checkbox">
					<input id="toggle" @change="${() => this.emit('check')}" type="checkbox" />
					<label for="toggle"></label>
				</div>
				<div>
					<div><label for="toggle"><strong>${this.question.name}</strong></label></div>
					Starts appearing on the ${intToOrdinal(this.question.appearanceOffsetDays + 1)} day.
					${this.question.appearanceIntervalDays === null ? 
						'Only appears once.' : 
						`Appears once every ${this.question.appearanceIntervalDays === 1 ? '' : intToOrdinal(this.question.appearanceIntervalDays)} day.`
					}
				</div>
			</div>
		`;
	}
}

customElements.define('pp-survey-question', SurveyQuestion);